"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dots = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importStar(require("@opsbase/web-css"));
const react_1 = __importDefault(require("react"));
const makeMyStyles = (color) => ({
    dot: {
        display: 'inline-block',
        width: 7,
        height: 7,
        marginRight: '2px',
        borderRadius: 7,
        backgroundColor: color.main,
    },
    animate1: {
        animation: 'dotty 1.4s infinite',
    },
    animate2: {
        animation: 'dotty 1.4s 250ms infinite',
    },
    animate3: {
        animation: 'dotty 1.4s 500ms infinite',
    },
});
function Dots(props) {
    const { color = lib_palette_1.default.White, hidden = false, style = {}, className } = props;
    const myCss = (0, web_css_1.default)(makeMyStyles, [color]);
    return (react_1.default.createElement("div", { className: className, style: Object.assign({ width: 'fit-content', height: 'fit-content', display: hidden ? 'none' : undefined }, style) },
        react_1.default.createElement("div", { className: (0, web_css_1.cx)(myCss.dot, myCss.animate1) }),
        react_1.default.createElement("div", { className: (0, web_css_1.cx)(myCss.dot, myCss.animate2) }),
        react_1.default.createElement("div", { className: (0, web_css_1.cx)(myCss.dot, myCss.animate3) })));
}
exports.Dots = Dots;
exports.default = Dots;
